<template>
  <div class="booking-screen fade-in">
    <div class="booking-screen__wrapper">
      <v-icon icon="mdi-close-circle" size="64" color="error" class="icon bounce" />
      <h2 class="text-error">
        {{ message }}
      </h2>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  message: string;
}

const { message } = defineProps<Props>();
</script>

<style scoped lang="scss">
  @use '../assets/sass/booking-screen';
</style>
